import {
  Box,
  Link,
  Stack,
  SimpleGrid,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Image,
} from "@chakra-ui/react";

import BaseLayout from "../../components/base_layout";
import { useState, useEffect } from "react";

export default function AllCategory() {
  const axios = require("axios").default;
  const [menu, setMenu] = useState("");

  const menuData = async () => {
    const menuURL =
      process.env.PANDA_API_URL + "/api/mallshop/getCategoryAtMobile";
    const menuRes = await axios.get(menuURL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setMenu(menuRes.data.data);
  };

  useEffect(() => {
    menuData();
  }, []);

  return (
    <BaseLayout>
      {menu.length > 0
        ? menu.map((datum) => (
            <Box className="base_container menu_category">
              <Box
                bg="#EAEBEC"
                p={4}
                mt={15}
                color="#333"
                className="menu_category_major"
              >
                <Heading as="h4" size="md">
                  <Link
                    href={datum.href}
                    className="all-category__title-hover all-category__title"
                  >
                    {" "}
                    {/* <Image
                      className="all-category__img"
                      // src="/images/category/cate1.png"
                    /> */}
                    {datum.name}
                  </Link>
                </Heading>
              </Box>
              {datum.attributes.length > 0
                ? datum.attributes.map((datum) => (
                    <>
                      <Box
                        bg=""
                        w="100%"
                        p={4}
                        color="black"
                        className="menu_category_middle"
                      >
                        <Heading as="h5" size="sm">
                          <Link
                            href={datum.href}
                            className="all-category__title-hover all-category__title"
                          >
                            {datum.name}
                          </Link>
                        </Heading>
                      </Box>

                      {datum.attributes
                        ? datum.attributes.map((datum) => (
                            <Box className="menu_category_minor">
                              <Stack
                                direction="row"
                                spacing={20}
                                // borderBottom="1px"
                                // borderColor="#EAEBEC"
                                fontSize={12}
                                className="menu_category_minor-child"
                              >
                                <Box
                                  columns={[2, null, 3]}
                                  spacing="20px"
                                  w="100%"
                                  p="5"
                                >
                                  <Link
                                    href={datum.href}
                                    className="all-category__content-hover all-category__title"
                                  >
                                    <li> {datum.name}</li>
                                  </Link>
                                </Box>
                              </Stack>
                            </Box>
                          ))
                        : ""}
                    </>
                  ))
                : ""}
            </Box>
          ))
        : ""}
    </BaseLayout>
  );
}
